/**
 * DiaryList — 日記「清單」睇法（設計 v2 S8／C19：日記／清單兩種睇法；UI v2 **步 10**）
 *   一頁一頁揭 ⇄ 清單；撳一行 → 跳去嗰頁
 */
import type { LibrarySong } from '../../hooks/useLibrary';
import { formatDate } from '../../components/DiaryCard';

export interface DiaryListProps {
  entries: LibrarySong[];
  locale: string;
  onOpen: (index: number) => void;
}

export default function DiaryList({ entries, locale, onOpen }: DiaryListProps) {
  return (
    <ul className="diary-list" data-testid="diary-list">
      {entries.map((s, i) => (
        <li key={s.id}>
          <button type="button" className="diary-list__item" onClick={() => onOpen(i)}>
            <span style={{ flex: 1, minWidth: 0 }}>
              <b>{s.title}</b>
              <small>{formatDate(s.createdAt, locale)}</small>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
